export default __webpack_public_path__ + "static/media/awesome-exclamation.0d1b26d8.svg";